import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=865f8baa&scoped=true"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865f8baa",
  null
  
)

export default component.exports